app.service('addressIntegrityValidator', function ($global) {

	function validateAddressIntegrity(data) {
		return $.ajax({
			url: '/customer-account-validate-address-integrity.ltr',
			dataType: 'json',
			async: false,
			data: {
				cityName: data.city,
				zipCode: data.zipCode,
				street: data.street,
				deliveryCityName: '',
				deliveryZipCode: '',
				deliveryAddressStreet: '',
				isInvoice: false,
				invoiceCityName: '',
				invoiceZipCode: '',
				invoiceAddressStreet: '',
				checkHomeAddress: true
			}
		});
	}

	$global('validateAddressIntegrity', validateAddressIntegrity);

	return {
		validateAddressIntegrity
	};
});